import request from './request'
import { WORK_TASK_QUERY_URL, LONG_WORK_URL, LONG_WORK_UPLOAD_URL, LONG_WORK_SIGN_URL, LONG_WORK_PUSH_URL } from './config'

export function createLongNovelByText (payload) {
  return request.post(LONG_WORK_URL, payload)
}

export function uploadLongNovelFile (formData, config) {
  return request.post(LONG_WORK_UPLOAD_URL, formData, config)
}

export function queryLongNovelTask (taskId) {
  return request.post(WORK_TASK_QUERY_URL, { taskId })
}

export function signLongNovel (payload) {
  return request.post(LONG_WORK_SIGN_URL, payload)
}

export function pushLongNovel (payload) {
  return request.post(LONG_WORK_PUSH_URL, payload)
}

